
import Swiper from 'swiper';

export default class Slider {
  constructor() {
    
    if(document.getElementsByTagName('html')[0].classList.contains('pc')){

        var mySwiper = new Swiper ('.swiper-container', {
          init: true,
          mode:'horizontal',//水平スクロール          
          // on: {//読み込み後のイベントの設定
          //   init: function(){
          //     // 任意の処理を実行
          //     document.querySelector('.swiper-container').classList.add('initialized')
          //   }
          // },
          slidesPerView: 2,//再度に見えている画像の数
          spaceBetween: 32,//余白
          centeredSlides : true,//centerへ
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          autoplay: {
            delay: 3000,
            disableOnInteraction: false//ユーザーの操作の後autoplayを中止しない
          }
        })
      
    } else {

        var mySwiper = new Swiper ('.swiper-container', {
          init: true,
          mode:'horizontal',//水平スクロール
          slidesPerView: 2,//再度に見えている画像
          spaceBetween: 16,//余白
          centeredSlides : true,//centerへ
          loop: true,
          // on: {
          //   init: function(){
          //     // 任意の処理を実行
          //     document.querySelector('.swiper-container').classList.add('initialized')
          //   }
          // },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          autoplay: {
            delay: 3000,//3秒ごとに切りかわる
            disableOnInteraction: false//操作があっても停止しない
          }
        })

    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/components/Slider.js